import solu_mo from "../../../assets/images/solu_mo.webp";
import solu_pc from "../../../assets/images/solu_pc.webp";
import ModalTH from "../../Modal/ModalTH";

export default function ProductssSolu() {
  return (
    <div className="w-full px-3 md:px-[40px] lg:px-[120px] py-[24px] md:py-[32px] lg:py-[40px]">
      <div className="container mx-auto flex flex-col gap-3 md:flex-row md:gap-6 lg:gap-3 p-0 md:p-3">
        <div className="flex flex-col gap-3 md:gap-4 md:w-1/2">
          <p className="text-[24px] md:text-[32px] lg:text-[36px] text-[#033F6A] font-semibold">
            Giải pháp tiên phong từ BlueSkyIT
          </p>
          <p className="text-[15px] md:text-[17px] lg:text-[16px] text-[#333333] font-normal md:w-full lg:w-[650px]">
            BlueSkyIT tự hào mang đến các sản phẩm đột phá trong lĩnh vực giáo
            dục, sức khỏe và đào tạo, được thiết kế để mang lại giá trị vượt
            trội cho cộng đồng
          </p>
          <ModalTH />
        </div>
        <div className="md:w-1/2 flex items-center justify-center">
          <img
            src={solu_mo}
            alt=""
            className="block md:hidden max-w-full h-auto"
          />
          <img
            src={solu_pc}
            alt=""
            className="hidden md:block max-w-full md:w-[350px] lg:w-[500px] h-auto object-cover"
          />
        </div>
      </div>
    </div>
  );
}
